import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { Stack } from "@mui/material";
import React, { FC } from "react";

type Props = {
  generateItinerary: () => void;
};

const Header: FC<Props> = ({ generateItinerary }) => {
  return (
    <Stack
      direction={"row"}
      justifyContent={"space-between"}
      className="w-full px-default"
    >
      <Stack gap={0.5}>
        <h1 className="text-title font-bold">ที่เที่ยวในแผนของฉัน</h1>
        <p className="text-gray-400 text-sm">(คุณสามารถแก้ไขได้ในหน้าถัดไป)</p>
      </Stack>
      <ArrowPathIcon onClick={() => generateItinerary()} className="size-6" />
    </Stack>
  );
};

export default Header;
